import RouteNames from '@/router/names';
import store from '../../../store';
import {
	B2B_VIEW_COMPANY_DETAILS,
	FINANCE,
	MANAGER,
	OWNER,
	POS_BUSINESS_FINANCE,
	POS_VIEW_BUSINESS_REVIEWS,
	POS_VIEW_DISCOUNTS,
	SUPER_ADMIN,
} from '@/middlewares/permissions';

const Dashboard = {
	name: 'Dashboard',
	slug: 'dashboard',
	icon: 'chart-line',
	baboonPermissions: [POS_BUSINESS_FINANCE],
	baboonUserAccess: [SUPER_ADMIN, OWNER, FINANCE],
	routeName: RouteNames.Dashboard,
};

const Discounts = {
	name: 'Discounts',
	slug: 'discounts',
	icon: 'gift',
	baboonPermissions: [POS_VIEW_DISCOUNTS],
	baboonUserAccess: [SUPER_ADMIN, OWNER, MANAGER],
	routeName: RouteNames.DiscountList,
};

const Orders = {
	name: 'Orders',
	slug: 'orders',
	icon: 'shopping-basket',
	submenu: [
		{
			routeName: RouteNames.OrdersKanban,
			name: 'Kanban',
			slug: 'ordersKanban',
		},
		{
			routeName: RouteNames.OrdersList,
			name: 'List',
			slug: 'ordersList',
		},
		{
			routeName: RouteNames.OrdersReviews,
			name: 'Reviews',
			slug: 'ordersReviews',
			baboonPermissions: [POS_VIEW_BUSINESS_REVIEWS],
			baboonUserAccess: [SUPER_ADMIN, OWNER, MANAGER],
		},
	],
};

const Menu = {
	name: 'Menu',
	slug: 'menu',
	icon: 'menu',
	routeName: RouteNames.BusinessMenu,
	submenu: [
		{
			routeName: RouteNames.BusinessMenu,
			name: 'Menu',
			slug: 'menu',
		},
		{
			routeName: RouteNames.ToppingsList,
			name: 'Toppings',
			slug: 'toppings',
		},
		{
			routeName: RouteNames.TopProducts,
			name: 'Top products',
			slug: 'topProducts',
			baboonUserAccess: [SUPER_ADMIN, OWNER, MANAGER],
		},
	],
};

const Business = {
	name: 'My Businesses',
	slug: 'my_businesses',
	icon: 'grid',
	routeName: RouteNames.MyBusinesses,
};

const Finance = {
	name: 'Finance',
	slug: 'finance',
	icon: 'wallet',
	baboonPermissions: [POS_BUSINESS_FINANCE],
	baboonUserAccess: [SUPER_ADMIN, OWNER, FINANCE],
	submenu: [
		{
			routeName: RouteNames.FinanceOverview,
			name: 'Overview',
			slug: 'financeOverview',
		},
		{
			routeName: RouteNames.Payments,
			name: 'Payments',
			slug: 'financePayments',
		},
		{
			routeName: RouteNames.Purchases,
			name: 'Purchases',
			slug: 'financePurchases',
		},
	],
};

const Reports = {
	name: 'Reports',
	slug: 'reports',
	icon: 'chart-line',
	baboonPermissions: [B2B_VIEW_COMPANY_DETAILS],
	baboonUserAccess: [SUPER_ADMIN, OWNER, MANAGER],
	submenu: [
		{
			routeName: RouteNames.DynamicReports,
			name: 'Dynamic Reports',
			slug: 'dynamic_reports',
		},
	],
};

export const getAvailableItems = () => {
	const items = [Dashboard, Orders];
	const user = store.getters['user'];
	if (!user) {
		return [];
	}
	items.push(Discounts);
	if (!user.restaurants || user.restaurants.length === 1) {
		items.push(Menu);
	} else {
		items.push(Business);
	}
	items.push(Finance);
	items.push(Reports);
	return items;
};
